import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { createBlock, createElementVNode, openBlock, renderSlot, unref, withCtx } from "vue";
import { DtInput } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_slot.vue
var _hoisted_1 = { class: "d-input__label-text d-label--sm" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlSlot" }, {
	props: {
		value: {
			type: void 0,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, e || null);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtInput), {
				value: __props.value,
				disabled: __props.disabled,
				spellcheck: "false",
				size: "sm",
				onInput: updateValue
			}, {
				labelSlot: withCtx(() => [createElementVNode("span", _hoisted_1, [renderSlot(_ctx.$slots, "default")])]),
				_: 3
			}, 8, ["value", "disabled"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_slot.vue.js.map